import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@gfe/core/services/icons/icons.service';
import { TooltipComponent } from '@gfe/shared/components/tooltip/tooltip.component';

export type CellOverlayAction = 'copy' | 'copy_raw' | 'edit' | 'go_to_reference' | 'filter';

const iconPerAction: Record<CellOverlayAction, string> = {
  copy: ICONS.copy,
  copy_raw: ICONS.bracketsCurly,
  edit: ICONS.pencil,
  go_to_reference: ICONS.arrowsOutCardinal,
  filter: ICONS.funnel
};

@Component({
  selector: 'app-actions-overlay',
  imports: [TooltipComponent, TranslatePipe],
  templateUrl: './actions-overlay.component.html',
  styles: ``
})
export class ActionsOverlayComponent {
  actions = input<CellOverlayAction[]>([]);

  executeAction = output<CellOverlayAction>();

  protected onActionClick(event: MouseEvent, action: CellOverlayAction): void {
    event.preventDefault();
    event.stopPropagation();
    this.executeAction.emit(action);
  }
  protected getTooltipKey(action: CellOverlayAction): string {
    return 'table.cell.overlay_actions.' + action + '.tooltip';
  }

  protected getIconClasses(action: CellOverlayAction): string {
    return iconPerAction[action];
  }
}
